import { Link } from "react-router-dom";
import { ChevronRightIcon, HomeIcon } from "@heroicons/react/20/solid";

export interface BreadcrumbPage {
  name: string;
  href?: string;
  current?: boolean;
  onClick?: (pages: BreadcrumbPage[]) => void;
}

interface BreadCrumbsProps {
  pgs?: BreadcrumbPage[];
  homeHref?: string;
}

export default function BreadCrumbs(props: BreadCrumbsProps) {
  const { pgs, homeHref = "/dashboard" } = props;
  const pages = pgs ?? [];

  if (pages.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className="flex">
      <ol className="flex items-center space-x-4">
        <li>
          <div>
            <Link
              to={homeHref}
              className="text-gray-400 hover:text-gray-500 dark:text-gray-500 dark:hover:text-gray-300"
            >
              <HomeIcon aria-hidden="true" className="size-5 shrink-0" />
              <span className="sr-only">Home</span>
            </Link>
          </div>
        </li>
        {pages.map((page, index) => (
          <li key={`${page.name}-${index}`}>
            <div className="flex items-center">
              <ChevronRightIcon
                aria-hidden="true"
                className="size-5 shrink-0 text-gray-400 dark:text-gray-500"
              />
              {page.href?.startsWith("/") && !page.onClick ? (
                <Link
                  to={page.href}
                  aria-current={page.current ? "page" : undefined}
                  className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                >
                  {page.name}
                </Link>
              ) : (
                <a
                  href={page.href}
                  aria-current={page.current ? "page" : undefined}
                  className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                  onClick={(e) => {
                    if (page.onClick) {
                      e.preventDefault();
                      page.onClick(pages);
                    }
                  }}
                >
                  {page.name}
                </a>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
